// extracted by mini-css-extract-plugin
export default {"root":"DailySummary_root__9pvCe","overlay":"DailySummary_overlay__pDggK"};